import axios from "axios";
import { store } from "../store/ConfigureStore";
import types from "./actionTypes";

const { dispatch } = store;

export function getHeaders() {
    let userData = localStorage.getItem("access_token");
    if (userData) {
        return {
            authorization: `Bearer ${userData}`,
        };
    }
    return {};
}

export async function apiReq(
    endPoint,
    data,
    method,
    headers,
    requestOptions = {}
) {
    return new Promise(async (res, rej) => {
        const getTokenHeader = getHeaders();
        headers = {
            ...getTokenHeader,
            ...headers,
        };

        if (method === 'get') {
            data = {
                ...requestOptions,
                ...data,
                headers
            };
        }
        if (method === 'delete') {
            data = {
                data: {
                    ...data
                }
            }
        }

        axios[method](endPoint, data, { headers })
            .then((result) => {
                const { data } = result;

                if (data.status === false) {
                    return rej(data);
                }

                return res(data);
            })
            .catch((error) => {
                if (error && error.response && error.response.status === 401) {
                    clearUserData();
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("isAuthenticated");

                    window.location = "/";
                }
                if (error && error.response && error.response.data) {
                    if (!error.response.data.message) {
                        return rej({
                            ...error.response.data,
                            msg: error.response.data.message || "Network Error",
                        });
                    }
                    return rej(error.response.data);
                } else {
                    return rej({ message: "Network Error", msg: "Network Error" });
                }
            });
    });
}

export function apiPost(endPoint, data, headers = {}) {
    return apiReq(endPoint, data, "post", headers);
}

export function apiDelete(endPoint, data, headers = {}) {
    return apiReq(endPoint, data, "delete", headers);
}

export function apiGet(endPoint, data, requestOptions, headers = {}) {
    return apiReq(endPoint, data, "get", headers, requestOptions);
}

export function apiPut(endPoint, data, headers = {}) {
    return apiReq(endPoint, data, "put", headers);
}

export async function apiPostWithStatusCode(endPoint, data) {
    const headers = getHeaders();
    return axios.post(endPoint, data, { headers });
}

export async function clearUserData() {
    return localStorage.removeItem("userData");
}
